export const Paths = {
    root: "/",
    assessmentInfo: "/assessment_info",
    assessmentSchedule: "/assessment_schedule",
    information: "/information",
    faq: "/faq",
    config: "/config",
    detection: "/detection",
    notificationEmail: "/email",
    serviceProvider: "/service_provider",
    user: "/user",
    careRecipient: "/care_recipient",
    addCareRecipient: "/care_recipient/new",
    careComment: "/care_comment",
    daily: "/daily",
    monthly: "/monthly",
    admin: "/admin",
    login: "/login",
    logout: "/logout",
    notRegistration: "/not_registration",
    role: "/role",
    add: "/add",
    edit: "/edit",
    list: "/list",
    dashBoard: "/dash_board",
    inquiry: "/inquiry",
    inquiryCompleted: "/inquiry/completed",
    loginLog: "/login_log",
    careCommentAnalysis: "/care_comment_analysis",
    changePassword: "/change_password",
    adminOperationLog: "/admin_operation_log",
    utilizationDocument: "/utilizationDocument",
};
